var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-info-component',{attrs:{"title":_vm.$t('pages.planing-team.widgets.employee_resting'),"value":_vm.value,"isLoading":_vm.initializing,"icon":"fa-moon","tone":"info"}})}
var staticRenderFns = []

export { render, staticRenderFns }